<template>
  <div>
    <v-btn
      fab
      bottom
      right
      color="pink"
      dark
      fixed
      @click.stop="dialog = !dialog"
    >
      <v-icon>add</v-icon>
    </v-btn>
    <v-dialog v-model="dialog" width="800px">
      <v-card>
        <v-card-title
          class="grey lighten-4 py-4 title"
        >
          <slot name="title"></slot>
        </v-card-title>
        <v-container grid-list-sm class="pa-4">
          <v-layout row wrap>
            <v-flex xs12 align-center justify-space-between>

              <slot name="itemInputField" :model="model"></slot>

            </v-flex>
            <v-flex xs12 sm6 md12>
              <v-text-field type="number" label="Amount" v-model="amount"></v-text-field>
            </v-flex>
            <v-flex xs12 align-center justify-space-between>
              <v-checkbox label="Is available" v-model="isAvailable"></v-checkbox>
            </v-flex>
            <v-flex xs12 align-center justify-space-between>
              <v-checkbox label="Is external vendor" v-model="isVendor"></v-checkbox>
            </v-flex>
            <v-flex xs12 align-center justify-space-between>
              <v-checkbox label="Edit checklist for the item after saving" v-model="editCheckListAfterSave"></v-checkbox>
            </v-flex>
            <ItemCheckList v-if="savedItemId > 0" :item-id="savedItemId" :item-type="itemTypeID"></ItemCheckList>
          </v-layout>
        </v-container>
        <v-card-actions>
          <v-btn color="primary" @click="saveNew" v-if="savedItemId === 0">Save</v-btn>
          <v-btn color="primary" v-else disabled>Saved</v-btn>

          <v-btn flat @click="dialog = false" v-if="savedItemId === 0">Cancel</v-btn>
          <v-btn flat @click="dialog = false" v-else>Close dialog</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <AppMainDialog :open="dialogOpen" :message="dialogMessage" @closedialog="dialogOpen = false"></AppMainDialog>
  </div>
</template>

<script>
  import AppMainDialog from '@/components/AppMainDialog'
  import AddButtonMixins from '@/mixins/AddButton'
  import ItemCheckList from '@/components/ItemCheckList'
  import itemTypesMixins from '@/mixins/ItemTypes'
  import inventoriesAPI from '@/api/resources/inventories'
  import servicesAPI from '@/api/resources/services'

  export default {
    components: { AppMainDialog, ItemCheckList },
    mixins: [ AddButtonMixins, itemTypesMixins ],
    computed: {
      itemsAPI () {
        switch (this.itemTypeID) {
          case this.inventoryTypeID: return inventoriesAPI
          case this.serviceTypeID: return servicesAPI
        }
      }
    },
    props: {
      itemTypeID: {
        type: Number,
        required: true
      }
    },
    data () {
      return {
        dialog: false,
        model: { name: '' },
        isAvailable: true,
        isVendor: false,
        amount: 0,
        dialogMessage: '',
        dialogOpen: false,
        editCheckListAfterSave: true,
        savedItemId: 0
      }
    },
    methods: {
      // TODO make object like itemData
      editCheckListAfterSaveMethod (result) {
        this.$bus.$emit('resource-added')

        this.savedItemId = result.inserted_id
      },
      saveNew () {
        let payload = {
          name: this.model.name,
          is_available: this.isAvailable,
          is_vendor: this.isVendor,
          amount: this.amount
        }

        let callback = null

        let result = this.itemsAPI.add(payload)

        if (this.editCheckListAfterSave) {
          callback = this.editCheckListAfterSaveMethod
        } else {
          callback = this.saveNewSuccess
        }

        result.then(callback, this.saveNewError)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// AppAddItemButtonBase.vue?06332364